$('span.open-sub').on('click', function () {
    // Close all sibling sub-menus and their children, excluding the current one and its descendants
    $(this).closest('ul').find('ul.sub-menu').not($(this).next('ul.sub-menu')).slideUp();

    // Toggle the current sub-menu
    $(this).next('ul.sub-menu').slideToggle();
});
